import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import { GdsCommonUtilityService } from '@upr-web-primer/gds-common-utility';
import { get } from 'lodash-es';

class GdsPictureModelModule {
}
GdsPictureModelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPictureModelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GdsPictureModelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPictureModelModule });
GdsPictureModelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPictureModelModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPictureModelModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

class GdsPictureModelService {
    constructor(injector) {
        this.injector = injector;
    }
    get utilities() {
        if (!this._utilities) {
            this._utilities = this.injector.get(GdsCommonUtilityService);
        }
        return this._utilities;
    }
    init(field, isXpath) {
        return {
            desktop: this.utilities.getImageUrl(field, 'desktop', true, 0, isXpath) ||
                this.utilities.resolveImagePath(get(field, 'desktop', '')),
            mobile: this.utilities.getImageUrl(field, 'mobile', true, 0, isXpath) ||
                this.utilities.resolveImagePath(get(field, 'mobile', '')),
            tablet: this.utilities.getImageUrl(field, 'tablet', true, 0, isXpath) ||
                this.utilities.resolveImagePath(get(field, 'tablet', '')),
            alt: get(field, 'EmbeddedValues[0].alt.Values[0]') || get(field, 'alt'),
            title: get(field, 'EmbeddedValues[0].title.Values[0]') || get(field, 'title')
        };
    }
    initRelatedTileImage(tileImage, isXpath) {
        return {
            desktop: this.utilities.getImageUrl(tileImage, 'HightResolutionImage', false, 0, isXpath),
            mobile: this.utilities.getImageUrl(tileImage, 'HightResolutionImage', false, 0, isXpath),
            tablet: this.utilities.getImageUrl(tileImage, 'HightResolutionImage', false, 0, isXpath),
            alt: get(tileImage, 'AltText'),
            title: get(tileImage, 'Title')
        };
    }
}
GdsPictureModelService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPictureModelService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
GdsPictureModelService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPictureModelService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPictureModelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

export { GdsPictureModelModule, GdsPictureModelService };
